import { createAppKit } from '@reown/appkit/react'
import { defaultNetwork, networks } from 'config/chains'

import { wagmiAdapter } from './config/wagmi'

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const projectId = import.meta.env.VITE_REOWN_PROJECT_ID!

const metadata = {
  name: 'Kodiak Finance',
  description: 'Kodiak Finance',
  url: 'https://app.kodiak.finance',
  icons: ['https://static.kodiak.finance/tokens/kdk.png'],
}

createAppKit({
  adapters: [wagmiAdapter],
  metadata,
  networks,
  defaultNetwork,
  allowUnsupportedChain: false,
  projectId,
  termsConditionsUrl: 'https://documentation.kodiak.finance/informational/terms-of-use',
  privacyPolicyUrl: 'https://documentation.kodiak.finance/informational/privacy-policy',
  enableWalletGuide: true,
  features: {
    // connectMethodsOrder: ['wallet', 'email'],
    swaps: false,
    analytics: true,
    email: false,
    socials: false,
    onramp: true,
    legalCheckbox: true,
  },
  featuredWalletIds: [
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96', //metamask
    '18388be9ac2d02726dbac9777c96efaac06d744b2f6d580fccdd4127a6d01fd1', //rabby
    '971e689d0a5be527bac79629b4ee9b925e82208e5168b733496a09c0faed0709', //okx
    // '38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662', //bitget
    // 'ecc4036f814562b41a5268adc86270fba1365471402006302e70169465b7ac18', //zerion
    // 'a797aa35c0fadbfc1a53e7f675162ed5226968b44a19ee3d24385c64d1d3c393', //phantom
    // 'fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa', //coinbase
    '8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4', //binance
    // '01b3720ae82d5aed3de295e3b7b226a75f8c22bdf823c47f57981bb791dd5850', //berasig
    // '5e4a8cc31d062b78a7ad9e017135574809b01c4dbbf30e4dbb467ddd43025618', //tomo
  ], //get WalletIDs here: https://docs.reown.com/cloud/wallets/wallet-list
  excludeWalletIds: [],
  allWallets: 'SHOW',
})
